import { IFProjectState } from '../initState/InterfacesState';

export const MapStateToProps = ({
  header,
  alert,
  stories,
  calculator,
  widthWindow,
  offsetContent,
  blog,
  blogMain,
  blogPopular,
  about,
  state404,
  blockedSend,
  recaptchaV2ref,
}: IFProjectState) => {
  return {
    header,
    alert,
    stories,
    calculator,
    widthWindow,
    offsetContent,
    blog,
    blogMain,
    blogPopular,
    about,
    state404,
    blockedSend,
    recaptchaV2ref,
  };
};
